var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackRefund(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#008CFF"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12.5 1.524v20.952M1.5 12.5h21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.631 8.801h5.215m-5.215 1.945h5.215m-4.974 1.946l2.976 3.063M9.936 8.801h1.131c1.39 0 2.53.875 2.53 1.945s-1.14 1.946-2.53 1.946h-1.13",
    strokeLinecap: "round",
    strokeWidth: 0.889
  }))));
}
export default SvgTrackRefund;